import React, { useState, useEffect, useRef, useCallback } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';
import URL, { DEV_MODE_AT } from '../../../../constants/url';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './HospitalLink.module.css';
import axiosApi from '../../../../api/daonAxios';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {
    getIsBirthSix, getNuPatientNumberByHospital
    //, getPatientNumberByHospital
} from '../../../../assets/js/comm';
import ToastPopup from '../../../../components/comm/ToastPopup';
import CODE from '../../../../constants/code';
import AlertBox from '../../../../components/box/AlertBox';
import Skeleton from '@mui/material/Skeleton';
import SERVER_STATE from '../../../../constants/url';


const HospitalLink = () => {

    /*****************
     * 주요 변수 선언부
    ******************/

    const navigate = useNavigate();
    const location = useLocation();
    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const [loading, setLoading] = useState(false);

    // 동의 내용 보기
    const [open, setOpen] = useState(false);

    // 진행 스텝
    const [step, setStep] = useState(0);

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //기본병원리스트
    const [ hospitalList, setHospitalList ] = useState([]);
    //기본병원리스트에서 선택된 병원
    const [ chooseHospital, setChooseHospital ] = useState([]);

    // 사용자 병원맵
    const [ hospitalMap, setHospitalMap ] = useState([]);
    // 사용자 이름
    const userNmRef = useRef('');
    const [ userNm, setUserNm ] = useState('');
    // 주민번호 첫자리
    const firstPidRef = useRef('');
    // 주민번호 뒷자리
    const lastPidRef = useRef('');

    // 주민번호 view
    const [ lastPidView, setLastPidView ] = useState(false);
    // 주민번호 유효검사
    const [ firstPidRule, setFirstPidRule ] = useState({
        lengthAt: false,
        birthAt: false
    });
    const [ lastPidRule, setLastPidRule ] = useState(false);
    // 본인인증 유효검사 //가입정보와 일치해야함. //이름 + 생년월일 ( 강도 : 중 )
    const [ userCertRule, setUserCertRule ] = useState({
        nameCheck: ( user?.usrNm !== undefined ? true : false ),
        birthCheck: false,
        genderCheck: false
        }); // 개발까지는 꺼둘 필요성이 있음.. 꺼두면 계정에 타환자랑 연결 가능.

    // 병원전체 선택
    const [ allHospitalCheck, setAllHospitalCheck ] = useState(false);

    // 동의 체크박스
    const [agreeCheck, setAgreeCheck] = useState(false);

    // 병원선택 체크박스 (validate 겸용)
    const [ hospitalCheck, setHospitalCheck ] = useState({});
    // 환자연동 체크박스 (validate 겸용)
    const [ patientCheck, setPatientCheck ] = useState({});

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);

    // 팝업
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertText, setAlertText ] = useState("");

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };

    const [policeInfo, setPoliceInfo] = useState({
            title : '',
            children  : ''
    });
    const [policeList, setPoliceList] = useState([]);

    /*****************
     * 기능 함수 선언부
     ******************/

    useEffect(() => {
        setOpen(false);

        if(isInitialRender) {
            // backend 에서 환자조회시 해당 메소드를 호출하는 버전으로 사용하게되면 무의미할수있으니 참조.. 25.08.28 개편됨.
            searchCmcHospitalList();
            searchHospitalPolicyId();
            isInitialRender.current = false;
        }
    }, []);

    function onDismiss() {
        setOpen(false);
    };

    const handleLastPidView = () => {
        setLastPidView(!lastPidView);
    };

    // 뒤로가기 액션
    const handleOnBack = () => {
        if(step >= 1 && step < 3) {
            setStep(step - 1);
        } else {
            navigate(URL.MAIN, {
                replace: true,
                state: { refreshAt: false }
            });
        }
    };

    /**
     * 기준정보 cmc 계열 병원 리스트 조회
     */
    const searchCmcHospitalList = () => {

        const requestCmcHospital = "/signup/retrieveCmcHospitalBaseList";

        axiosApi.post(requestCmcHospital, {})
            .then( (res) => {
                const resData = res.data;
                if( resData.resultCode === CODE.RCV_SUCCESS ) {
                    const hospitalList = resData.result.hospitalList;
                    if( hospitalList.length > 0 ) {
                        let checkedObj = {};
                        let idx = 1;
                        hospitalList.forEach( (item) => {
                            checkedObj = { ...checkedObj, ["choose"+idx]: false };
                            idx++;
                        });
                        setHospitalList(hospitalList);
                        setHospitalCheck(checkedObj);
                    }
                } else {
                    setHospitalList([]);
                }
            })
            .catch( err => {
                console.log(" ==================> searchCmcHospitalList error : ", err );
            })
    };

    /**
     * 인풋박스 텍스트 온체인지 이벤트 처리
     * @param e
     */
    const handleOnChangeInput = (e) => {

        const inputName = e.target.name;
        //console.log( " ======> input event : ", e.target.name );
        if( inputName === "userNm" ) {
            const inputUserNm = userNmRef.current;
            if( inputUserNm ) {
                const nameCheck = inputUserNm.value === user?.usrNm  // 가입한 이름이 동일한지 ..
                setUserCertRule({ ...userCertRule, nameCheck: nameCheck });
            }
        }
        if( ["firstPid", "lastPid"].includes(inputName) ) {
            // 숫자 정규식 check
            const inputPid = inputName === 'firstPid' ? firstPidRef.current : lastPidRef.current;

            if(inputName === 'firstPid') {
                const lengthAt = inputPid.value.length === 6;
                const birthAt = getIsBirthSix(inputPid.value.trim());
                if( user?.brthdy !== undefined ) {
                    const birth = user.brthdy.length === 8 ? user.brthdy.substring(2, 8) : user.brthdy.length;
                    const birthCheck = birth === inputPid.value;
                    setUserCertRule( { ...userCertRule, birthCheck: birthCheck } );
                } else {
                    // 가입시 생년월일이 없는 경우는... 우선 통과시켜줌.  //추후 정확한 진단을 위해 막아야할수 있음.
                    setUserCertRule( { ...userCertRule, birthCheck: true } );
                }
                setFirstPidRule({ lengthAt, birthAt });
            } else {
                const lengthAt = inputPid.value.length === 7;
                if( user?.gendr !== undefined ) {
                    let genderCheck = false;
                    const genderChar = inputPid.value.substring(0, 1);
                    if( user.gendr === "1" ) {
                        genderCheck = ['1', '3', '5', '7'].includes(genderChar);
                    } else if ( user.gendr === "0" ) {
                        genderCheck = ['2', '4', '6', '8'].includes(genderChar);
                    }
                    setUserCertRule( { ...userCertRule, genderCheck: genderCheck });
                } else {
                    // 가입시 성별이 없는 경우는... 우선 통과시켜줌.  //추후 정확한 진단을 위해 막아야할수 있음.
                    setUserCertRule( { ...userCertRule, genderCheck: true } );
                }
                setLastPidRule(lengthAt);
            }
        }
    };


    /**
     * 체크박스 온체인지 이벤트
     * @param e
     */
    const handleOnChangeCheck = (e) => {

        const newVal = e.target.checked;
        const checkedId = e.target.id;

        if( checkedId === "require-chk2") {
            setAgreeCheck(newVal);
        }
        /* 기준병원정보 추가 .. */
        if( checkedId.indexOf("choose") > -1) {

            let checkedObj = { ...hospitalCheck, [checkedId]: newVal };
            setHospitalCheck( checkedObj );
        }
        /* 환자연동시 .. (기존) */
        if( checkedId.indexOf("select") > -1) {
            // 기본이 이렇슴..
            //let checkedObj = { ...patientCheck, [checkedId]: newVal };
            let checkedObj = {};
            // 초기화 ...
            //let patientObj = [ ...hospitalMap ];
            //let patientItem = {};
            //const checkedIdx = checkedId.charAt(checkedId.length - 1);
            let idx = 1;
            hospitalMap.forEach( (item) => {
                /*
                if(idx === checkedIdx) {
                    patientItem = { ...item, hsptlSortOrdr: 1 };
                    patientObj.forEach( (item) => {

                    })
                }*/
                checkedObj = { ...checkedObj, ["select"+idx]: false };
                idx++;
            });
            checkedObj = { ...checkedObj, [checkedId]: newVal };

            setPatientCheck( checkedObj );
        }
    };

    const handleOnHospitalLink = async () => {

        if( step === 0 ) {
            let checkAt = false;
            let checkKeyId = "choose";
            let arrHospital = [];
            let hospitalText = ""; // 선택병원 텍스트
            for (let key in hospitalCheck) {
                // 필요한 조건에 맞춰 연산 가능
                if(hospitalCheck[key]) { // 체크여부 확인
                    checkKeyId = key;
                    checkAt = hospitalCheck[key];
                    const indexNumber = Number(checkKeyId.charAt(checkKeyId.length - 1));
                    const arrayIndex = indexNumber - 1;

                    if(hospitalList[arrayIndex]) {
                        arrHospital.push({
                            hospitalCd: hospitalList[arrayIndex].insttClCd
                            , cnncHsptlNm: hospitalList[arrayIndex].insttNm
                        });
                        hospitalText += hospitalList[arrayIndex].insttNm + ", ";
                    }
                }
            }

            hospitalText  = hospitalText.replace(/,\s*$/, '');
            let hospitalTextMain =  policeInfo.children.replaceAll("%^선택병원%", hospitalText);

            if(!checkAt) {
                setToastMessage("하나 이상의 병원을 선택해 주세요");
                setToast(true);
                return false;
            }
            setChooseHospital( arrHospital );
            // 약관 선택병원으로 셋팅처리
            setPoliceInfo( {...policeInfo, children: hospitalTextMain} );
            setStep(1);
        }

        if( step === 1 ) {
            const userHospitalArr = await searchPatientByHospital();

            if (userHospitalArr.length > 0) {
                //console.log(" ============> searchPatientByHospital 완료 : ", userHospitalArr);
                setStep(2);
            }
        }
        // next step
        if( step > 1 ) {

            let checkAt = false;
            let checkKeyId = "select";
            for (let key in patientCheck) {
                // 필요한 조건에 맞춰 연산 가능
                if(patientCheck[key]) {
                    checkKeyId = key;
                    checkAt = patientCheck[key];
                }
            }
            if(!checkAt) {
                setToastMessage("대표 병원을 선택해 주세요");
                setToast(true);
                return false;
            }
            let patientObj = [];
            const checkedIdx = checkKeyId.charAt(checkKeyId.length - 1);
            let idx = 1;
            hospitalMap.forEach( (item) => {
                if(idx === Number(checkedIdx)) {
                    patientObj.push({ ...item, hsptlSortOrdr: 1 }); // 대표선택
                } else {
                    patientObj.push({ ...item, hsptlSortOrdr: idx + 1 });
                }
                idx++;
            });

            const requestUserHospitalConnect = "/signup/saveUserHospitalConnect";

            const jToken = localStorage.getItem('jToken');

            const requestOptions = {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                }
            }

            const requestData = {
                usrInfoId: user.usrInfoId,
                add: patientObj
            }

            axiosApi.post(requestUserHospitalConnect, requestData, requestOptions)
                .then( (res) => {
                    const resData = res.data;
                    if( resData.resultCode === CODE.RCV_SUCCESS ) {
                        const aftcrUser = resData.result.aftcrUser;
                        // 유저정보 세션 re 셋팅 : 병원정보 업데이트
                        sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser));
                        // 완료시
                        navigate(URL.HOSPITAL_LINK_COMPLETE, { state: patientObj });
                    } else {
                        //저장실패시 ...
                        setToastMessage("저장에 실패하였습니다. 다시 시도해주세요.");
                        setToast(true);
                    }
                })
                .catch( (err) =>{
                    console.log(" =============> handleOnHospitalLink step 2 Error : ", err);
                })
        }
    };

    /**
     * 환자번호 연동
     * @returns {boolean}
     */
    const searchPatientByHospital = async (reqHsptlList) => {

        // console.log ( " searchPatientByHospital userCertCheck : ", userCertRule );
        if(userNmRef.current.value.length < 1) {
            setToastMessage("이름을 입력해주세요");
            setToast(true);
            return false;
        }
        if(!firstPidRule.lengthAt) {
            setToastMessage("주민번호 앞자리 6자리를 정확히 입력해주세요.");
            setToast(true);
            return false;
        }
        if(!firstPidRule.birthAt) {
            setToastMessage("주민번호 생년월일 형식이 잘못되었습니다.");
            setToast(true);
            return false;
        }
        if(!lastPidRule) {
            setToastMessage("주민번호 뒷자리 7자리를 정확히 입력해주세요.");
            setToast(true);
            return false;
        }
        if(!agreeCheck) {
            // setToastMessage("서비스 이용을 위해 약관 동의가 필요합니다.");
            // setToast(true);
            setAlertText("서비스 이용을 위해 약관 동의가 필요합니다.")
            setIsAlertOpen(true)
            return false;
        }
        // 김하용, 가입정보와 입력정보 유효검사로.. 운영시 주석해제 필수임!!!
        if(!DEV_MODE_AT) { // 연구팀 테스트를 위해 ~ 운영인 경우만 체크하도록 조정..
            if (!userCertRule.nameCheck || !userCertRule.birthCheck || !userCertRule.genderCheck) {
                setToastMessage("가입한 정보와 환자정보가 상이합니다. \n정확히 본인 정보를 입력해주세요.");
                setToast(true);
                return false;
            }
        }

        console.log( " ================> handleOnSearchPatientByHospital start <======= ");
        const searchInfo = {
            patientNm: userNmRef.current.value,
            regidentNo: firstPidRef.current.value + lastPidRef.current.value,
            //hospitalCd: "" //
            reqHsptlList: chooseHospital
        };

        let objArr = [];
        let idx = 0;
        let errIdx = 0;
        /* 25.08.28.자로 개편.. 백엔드 우회호출 변경으로 인하여.. (원인: 인프라 환경 요인)
        for(let hospital of hospitalList) {
            //console.log(" handleOnSearchPatientByHospital HOSPITAL_GRP : ", item);
            searchInfo.hospitalCd = hospital?.insttClCd;
            if( searchInfo.hospitalCd ) {
                // 로딩 필요시 ... 동글뱅이...
                await getPatientNumberByHospital(searchInfo)
                    .then((res) => {
                        const result = res?.root?.list?.result;
                        if (result) {
                            objArr.push({
                                usrInfoId: user.usrInfoId,
                                cnncHsptlCd: result.hospitalCd,
                                cnncHsptlNm: hospitalList.filter((data) => data.insttClCd === searchInfo.hospitalCd)[0].insttNm,
                                cnncPatntNo: result.patientId,
                                hsptlSortOrdr: idx++
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(" ===============> getPatientNumberByHospital error : ", err);
                        errIdx++;
                    });
            } else {
                errIdx++;
            }
        }
        */
        await getNuPatientNumberByHospital(searchInfo)
            .then((res) => {
                const resData = res;

                if( resData.resultCode === CODE.RCV_SUCCESS ) {
                    const nuPatientList = resData.result.nuPatientList;
                    if( nuPatientList.length > 0 ) {
                        //console.log( " ===============> searchNuPatientNumberByHospital : ", nuPatientList );
                        nuPatientList.forEach( (item) => {
                            objArr.push({
                                usrInfoId: user.usrInfoId,
                                cnncHsptlCd: item.hospitalCd,
                                cnncHsptlNm: item.cnncHsptlNm,
                                cnncPatntNo: item.patientId,
                                hsptlSortOrdr: idx++
                            });
                        });
                    }
                } else {
                    errIdx = 1;
                }
            })
            .catch((err) => {
                console.log(" ===============> getNuPatientNumberByHospital error : ", err);
                errIdx = 1;
            });

        if(errIdx > 0) {
            // setToastMessage("일치하는 환자 정보가 없습니다");
            // setToast(true);
            setAlertText("환자정보 조회가 실패하였습니다.\n입력한 정보를 확인하시고,\n다시 시도해 주세요.\n(* 현재 시범운영 중으로 서울, 은평, 인천, 부천성모병원만 조회 가능합니다)");
            setIsAlertOpen(true);
            return false;
        }
        if( objArr.length > 0 ) {

            let checkGrp = {};
            // 운영시 주석처리 필수..
            //objArr = samplePatientMappingData(objArr, idx, 2);

            let objIdx = 1;
            objArr.forEach( (item) => {
               if(objIdx === 1) {
                   checkGrp = { ...checkGrp, ["select" + objIdx]: true };
               } else {
                   checkGrp = { ...checkGrp, ["select" + objIdx]: false };
               }
               objIdx++;
            });

            setPatientCheck(checkGrp);
            // console.log( " =============> 등록된 병원조회수 : ", objArr.length );
            setHospitalMap(objArr);
            setUserNm(userNmRef.current.value); // 최종 셋팅한 이름.
        } else {
            // 맵핑 병원이 0인 경우,  2025.12.22, 현재는 errIdx 가 정상조회시에도 카운트되서.. 이쪽으로 분기 탈 일이 없을듯 함.. 참고.
            // 오픈후 메시지
            //setToastMessage("환자번호가 존재하지 않습니다.\n 문제가 지속시 관리자에게 문의해주세요.");
            // 오픈전 메시지
            setToastMessage("환자정보가 존재하지 않습니다.\n입력한 정보를 확인하시고, 다시 시도해 주세요.\n(* 현재 시범운영 중으로 서울, 은평 ,인천, 부천성모병원만 조회 가능합니다)");
            setToast(true);
            return false;
        }

        console.log( " =======> handleOnSearchPatientByHospital end <================ ");

        return objArr;
    };

    /**
     * 병원맵핑 환자 샘플데이터 생성 ( 최대 4개까지만 허용, 기본 1개 ) ...
     *  개발 및 테스트 용이며 운영에선 사용되지 않음
     * @param object
     * @param idx
     * @param number
     */
    const samplePatientMappingData = (object, idx, number = 1) => {

        const samplePatient = [
            { cnncHsptlCd: "014", cnncHsptlNm: "부천성모병원(샘플)", cnncPatntNo: "10001402", hsptlSortOrdr: 2, usrInfoId: user.usrInfoId }
            , { cnncHsptlCd: "016", cnncHsptlNm: "인천성모병원(샘플)", cnncPatntNo: "10006002", hsptlSortOrdr: 3, usrInfoId: user.usrInfoId }
            , { cnncHsptlCd: "015", cnncHsptlNm: "은평성모병원(샘플)", cnncPatntNo: "10015002", hsptlSortOrdr: 4, usrInfoId: user.usrInfoId }
            , { cnncHsptlCd: "012", cnncHsptlNm: "서울성모병원(샘플)", cnncPatntNo: "40184412", hsptlSortOrdr: 5, usrInfoId: user.usrInfoId }
        ];
        object.push({ ...samplePatient[0], hsptlSortOrdr: idx++ });

        if( number > 1 && number < 4) {
            if(number === 2) {
                object.push({ ...samplePatient[1], hsptlSortOrdr: idx++ });

            }
            if(number === 3) {
                object.push({ ...samplePatient[1], hsptlSortOrdr: idx++ });
                object.push({ ...samplePatient[2], hsptlSortOrdr: idx++ });
            }
            if(number === 4) {
                object.push({ ...samplePatient[1], hsptlSortOrdr: idx++ });
                object.push({ ...samplePatient[2], hsptlSortOrdr: idx++ });
                object.push({ ...samplePatient[3], hsptlSortOrdr: idx++ });
            }
        }
        return object;
    };

    // number 길이 체크
    const lengthChk = (e)=>{
        if (e.target.value.length > e.target.maxLength)
            e.target.value = e.target.value.slice(0, e.target.maxLength);
    }

    const baseSettingByHospital = () => {

        const hospitalTag = [];

        let selectIdx = 1;


        hospitalList.forEach( (item) => {
            hospitalTag.push(
                <li key={selectIdx}>
                    <div className="chkbox-custom" data-chkbox="basic">
                        <input type="checkbox" id={"choose"+selectIdx} name={"choose"+selectIdx}
                               checked={hospitalCheck["choose"+selectIdx]}
                               onChange={handleOnChangeCheck}
                        />
                        <label htmlFor={"choose" + selectIdx }>
                            <div className={style['txt-box']}>
                                <p>{ item.insttNm }</p>
                            </div>
                        </label>
                    </div>
                </li>
            )
            selectIdx++;
        });

        return hospitalTag;
    }


    const patientSettingByHospital = () => {

        const patientTag = [];

        let selectIdx = 1;
        hospitalMap.forEach( (item) => {

            patientTag.push(
                <li key={selectIdx}>
                    <div className="chkbox-custom" data-chkbox="chk-to-ridio">
                        <input type="checkbox" id={"select"+selectIdx} name={"select"+selectIdx}
                               checked={patientCheck["select"+selectIdx]}
                               onChange={handleOnChangeCheck}
                        />
                        <label htmlFor={"select" + selectIdx }>
                            <div className={style['txt-box']}>
                                <p>{ item.cnncHsptlNm }</p>
                                <span>{ item.cnncPatntNo }</span>
                            </div>
                        </label>
                    </div>
                </li>
            )
            selectIdx++;
        });

        return patientTag;
    }

    //약관 목록 호출
    const searchHospitalPolicyId = () => {

        const url = `/signup/retrieveHospitalPolicyIdList`;

        axiosApi.post(url, ["D"])
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const list = res.data.result.result;

                setPoliceList(list);

                if (list.length > 0) {
                    setPoliceInfo({
                        title: list[0].stplatPolicySj,
                        children: list[0].stplatPolicyCn
                    });
                }
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("searchHospitalPolicyId err : ", err);
        })
    };

    const handleClickPolicBtn = () => {

        if (policeInfo.title && policeInfo.children ) {
            setOpen(true);
        } else {
            setToastMessage("약관 정보를 불러올 수 없습니다.");
            setToast(true);
        }
    };

    // 체크박스 전체 선택
    const handleAllCheck = (checked) => {
        let checkedObj = { ...hospitalCheck };

        if(checked) {
            // 전체 선택: 모든 병원을 true로 설정
            for( let key in checkedObj ) {
                checkedObj = { ...checkedObj, [key]: true };
            }
        } else {
            // 전체 해제: 모든 병원을 false로 설정
            for( let key in checkedObj ) {
                checkedObj = { ...checkedObj, [key]: false };
            }
        }
        setHospitalCheck(checkedObj);
    };

    useEffect(() => {
        if (hospitalList.length > 0 && Object.keys(hospitalCheck).length > 0) {
            const allChecked = Object.values(hospitalCheck).every(val => val === true);
            setAllHospitalCheck(allChecked);
        }
    }, [hospitalCheck, hospitalList]);


    return (
        <>
            <HeadSub title="병원 환자번호 연동" onBack={handleOnBack} />

            {/* 내정보수정으로 변경 (2026.01.21)*/}
            <div className={style['quit-btn-box']}>
                <button className={style['quit-btn']}
                        onClick={() =>
                            navigate(URL.MYINFO_WRITE, { state: {
                                    from: location.pathname, // 또는 location (search, state 포함)
                                }
                            })
                        }>
                    <span className="blind"></span>
                </button>
            </div>

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">

                    {/* 기본병원정보 셋팅 S */}
                    { step === 0 &&
                    <div className='animation-2'>
                        <div className={style['compotent-box']}>

                            <div className={style['content-box']}>
                                <strong className={style['title']}>
                                    연동하고자 하는 병원을 <br />모두 선택해 주세요
                                </strong>

                                <p className='text-align-center m-t-24'> 현재 시범 운영 중으로,<br />
                                    아래 병원에 한해 환자번호 연동이 제공되며<br />
                                    선택한 병원에 내 환자 정보가 존재하지 않을 경우
                                    연결이 불가능합니다
                                </p>
                            </div>

                            <div className={style['content-box']}>
                                <div className={style['selecting-box']} data-type="b">
                                    <ul>

                                        {/* 모두 선택 */}
                                        { hospitalList.length > 0 &&
                                            <li className={style['all-select-chkbox']}>
                                                <div className="chkbox-custom" data-chkbox="basic">
                                                    <input type="checkbox" id={"select-all"} name={"select-all"}
                                                        onChange={(e) => handleAllCheck(e.target.checked)}
                                                        checked={allHospitalCheck}
                                                    />
                                                    <label htmlFor={"select-all" }>
                                                        <div className={style['txt-box']}>
                                                            <p>모두 선택</p>
                                                        </div>
                                                    </label>
                                                </div>
                                            </li>
                                        }

                                        { hospitalList.length > 0 &&
                                            baseSettingByHospital()
                                        }

                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                    }
                    {/* 기본병원정보 셋팅 E */}

                    {/* 이름 생년월일 확인 컴포넌트  */}
                     { step === 1 &&
                     <div className='animation-2'>
                        <div className={style['compotent-box']}>

                            <div className={style['content-box']}>
                                <strong className={style['title']}>
                                    환자번호 연동을 진행합니다. <br />
                                    이름과 생년월일을 확인해주세요.
                                </strong>

                                <div className={style['input-wrap']}>
                                    <span className={style['input-tit']}>생년월일</span>

                                    <div className={style['birth-input-box']}>
                                        <div className={style['input-box']}>
                                            <input type="number" name="firstPid"
                                                   placeholder="주민번호 앞자리"
                                                   maxLength={6}
                                                   ref={firstPidRef}
                                                   onInput={lengthChk}
                                                   onChange={handleOnChangeInput}
                                                   inputMode="numeric"     // 모바일에서 숫자 키패드
                                                   pattern="[0-9]*"        // 숫자만 허용
                                            />
                                            <span className={style['line']}
                                                  data-discord={
                                                    firstPidRef.current?.value && (!firstPidRule.lengthAt || !firstPidRule.birthAt)
                                                    ? 'on'
                                                    : undefined
                                                }></span>
                                        </div>

                                        <div className={style['input-box']}>
                                            <div className={style['pw-box']}>
                                                <input type={lastPidView ? 'text' : 'password'} name="lastPid"
                                                       placeholder="주민번호 뒷자리"
                                                       maxLength={7}
                                                       ref={lastPidRef}
                                                       onInput={lengthChk}
                                                       onChange={handleOnChangeInput}
                                                       inputMode="numeric"     // 모바일에서 숫자 키패드
                                                       pattern="[0-9]*"        // 숫자만 허용
                                                />
                                                <span className={style['line']}
                                                      data-discord={
                                                        lastPidRef.current?.value && !lastPidRule
                                                        ? 'on'
                                                        : undefined
                                                    }></span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className={style['input-wrap']}>
                                    <span className={style['input-tit']}>이름</span>
                                    <div className={style['input-box']}>
                                        <input type="text" name="userNm"
                                               ref={userNmRef}
                                               defaultValue={ user?.usrNm ? user?.usrNm : '' }
                                               placeholder="이름을 입력해주세요"
                                               onChange={handleOnChangeInput}
                                               disabled={DEV_MODE_AT ? false : true}
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                </div>

                            </div>

                            <div className={style['agree-box']}>
                                <div className={style['top']}>
                                    <p>병원 연동을 위해 개인정보 활용에 동의해 주세요.</p>
                                    <span>동의 시, 본 서비스의 운영 주체 및 연동된 병원에 한하여 환자 정보가 제공 및 활용될 수 있습니다.</span>
                                    {/* <p>환자번호 조회를 위해 <br />
                                        개인정보 활용에 동의해 주세요</p> */}
                                </div>
                                <div className={style['botm']}>
                                    <div className='chkbox-custom' data-chkbox='basic'>
                                        <input type="checkbox" id='require-chk2' checked={agreeCheck} onChange={handleOnChangeCheck} />
                                        <label htmlFor="require-chk2">
                                            <div className={style['txt-box']}>
                                                <b>&#91;필수&#93;</b> <p>{policeInfo.title}</p>
                                            </div>
                                        </label>
                                    </div>

                                    <button className={style['more-btn']} onClick={() => handleClickPolicBtn()}>
                                        <span>보기</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                     </div>
                     }

                    {/* 병원 선택 컴포넌트 */}
                    { step > 1 &&
                    <div className='animation-2'>
                        <div className={style['compotent-box']}>

                            <div className={style['content-box']}>
                                <strong className={style['title']}>
                                아래 병원에서 <br />
                                    { userNm }
                                    님의 환자번호가 확인되었습니다

                                <p>대표 병원을 선택해 주세요</p>

                                </strong>
                            </div>

                            <div className={style['content-box']}>
                                <div className={style['selecting-box']}>
                                    <ul>
                                        { hospitalMap.length > 0 &&
                                            patientSettingByHospital()
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                        {/* 하단 다음 버튼 영역 :: S */}
                        <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className='btn-layout' data-btn-num="1">

                                    {/* <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={onSubmit}>
                                        <span>다음</span>
                                    </button> */}
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleOnHospitalLink}>
                                        <span>{ step < 2 ? '다음' : '연동하기' }</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                        {/* 하단 다음 버튼 영역 :: E */}



                        {/* // 로딩 관련
                        <div className={style['last-loading-box']}>
                            <div className='animation-3'>
                                <p>
                                    <b>{user.usrNm}</b>님의 의료 정보를 <br />
                                    보기 편하게 요약하고 있어요.
                                </p>
                                <strong>잠시만 기다려주세요!</strong>
                                <div className={style['img-box']}>
                                    <img src={imgLastLoading} alt="" />
                                </div>
                            </div>
                        </div>
                        */}

                        <BottomSheet

                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지

                            open={open}
                            onDismiss={onDismiss}
                            snapPoints={({ maxHeight }) => [
                                maxHeight - maxHeight / 10,
                                maxHeight * 0.6,
                              ]}
                            blocking={true}
                            // className={style['header-top']}
                            >
                            <AgreeConditionsBox onClose={onDismiss} title={policeInfo.title} children={policeInfo.children}/>
                        </BottomSheet>

                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            position='center'
                        />
                    )}

                </div>
                <AlertBox
                        isOpen={isAlertOpen}
                        onClose={handleOnAlertClose}
                        message={alertText}
                        btnTxt='확인'
                 />
        </>
    )
}

export default HospitalLink
